import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect, useState } from 'react';
import { bool, func, node, number, oneOf, oneOfType, string } from 'prop-types';
import Flex from '../../atoms/Flex';
import Checkbox from '../../atoms/Checkbox';
import withWrapper from './withWrapper';
import { useListContext } from './list-context';
import { Item } from './list.styles';

const ListCheckbox = _ref => {
  let {
    as,
    checked,
    children,
    content,
    defaultChecked,
    description,
    endIcon,
    fill,
    value,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "checked", "children", "content", "defaultChecked", "description", "endIcon", "fill", "value", "onClick"]);

  const [isChecked, setIsChecked] = useState(checked);
  const {
    variant,
    scale,
    basis,
    gutters,
    selectable
  } = useListContext();

  const handleOnClick = e => {
    setIsChecked(!isChecked);
    onClick(e);
  };

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement(Item, _extends({
    forwardedAs: as,
    variant: variant,
    startIcon: /*#__PURE__*/React.createElement(Flex, {
      width: basis
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: isChecked,
      defaultChecked: defaultChecked,
      value: value
    })),
    endIcon: endIcon,
    description: description,
    content: content,
    selectable: selectable,
    scale: scale,
    gutters: gutters,
    fill: fill,
    onClick: handleOnClick,
    "data-testid": "list-checkbox"
  }, props), children);
};

process.env.NODE_ENV !== "production" ? ListCheckbox.propTypes = {
  as: string,
  checked: bool,
  children: node,
  content: node,
  defaultChecked: bool,
  description: node,
  endIcon: node,
  fill: string,
  value: oneOfType([string, number]),
  variant: oneOf(['light', 'primary', 'transparent', 'base']),
  onClick: func
} : void 0;
ListCheckbox.defaultProps = {
  checked: false,
  children: null,
  endIcon: '',
  fill: 'currentColor',
  onClick: () => {}
};
export default withWrapper(ListCheckbox);